module.exports = __webpack_public_path__ + "static/media/international_people_to.5e101de7.png";